// CarouselBanner.js
import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const CarouselBanner = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
  };

  const slides = [
    {
      id: 1,
      image: 'https://www.captureatrip.com/_next/image?url=https%3A%2F%2Fcaptureatrip-cms-storage.s3.ap-south-1.amazonaws.com%2Fmeghalaya_1_66a36f863a.jpg&w=1920&q=50',
      title: 'Explore the World',
      description: 'Discover beautiful destinations and amazing cultures.',
    },
    {
      id: 2,
      image: 'https://www.captureatrip.com/_next/image?url=https%3A%2F%2Fcaptureatrip-cms-storage.s3.ap-south-1.amazonaws.com%2FOrange_Retro_India_Travel_You_Tube_Banner_1500_x_400_px_7baae85afa.png&w=1920&q=50',
      title: 'Adventure Awaits',
      description: 'Embark on thrilling adventures and create unforgettable memories.',
    },
    {
      id: 3,
      image: 'https://www.captureatrip.com/_next/image?url=https%3A%2F%2Fcaptureatrip-cms-storage.s3.ap-south-1.amazonaws.com%2FNewyear_Trips_20bc99765a.webp&w=1920&q=50',
      title: 'Relax and Unwind',
      description: 'Enjoy serene beaches and tranquil landscapes.',
    },
  ];

  return (
    <div className="relative w-full max-h-[380px] overflow-hidden px-14 py-10 mb-3 bg-[#244849]">
      <Slider {...settings}>
        {slides.map((slide) => (
          <div key={slide.id} className="relative">
            <img 
              src={slide.image} 
              alt={slide.title} 
              className="w-full h-[400px] object-cover rounded-lg" // Fixed height of 400px
            />
            {/* <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 text-center text-white">
              <h2 className="text-2xl font-bold">{slide.title}</h2>
              <p className="mt-2 text-lg">{slide.description}</p>
            </div> */}
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default CarouselBanner;
